class ReviewSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        const swiperEl = this.querySelector('.section-review-slider-swiper');
        if (!swiperEl) return;

        this.swiper = new Swiper(swiperEl, {
            loop: true,
            centeredSlides: true,
            watchOverflow: true,
            speed: 600,
            slidesPerView: 1.4,
            spaceBetween: 0,
            navigation: {
                nextEl: this.querySelector('.section-review-slider-next'),
                prevEl: this.querySelector('.section-review-slider-prev'),
            },

            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                    centeredSlides: true,
                    spaceBetween: 5
                },
                576: {
                    slidesPerView: 1.4
                },
                768: {
                    slidesPerView: 1.5
                }, 
                990: {
                    slidesPerView: 2
                },
            }
        });
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

if (!customElements.get('review-slider')) {
    customElements.define('review-slider', ReviewSlider);
}